import { render } from "./ClassBookingView.vue?vue&type=template&id=a4b7db4a&scoped=true"
import script from "./ClassBookingView.vue?vue&type=script&lang=js"
export * from "./ClassBookingView.vue?vue&type=script&lang=js"

import "./ClassBookingView.vue?vue&type=style&index=0&id=a4b7db4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4b7db4a"]])

export default __exports__